import { render, staticRenderFns } from "./addBid.vue?vue&type=template&id=272ddc38&scoped=true"
import script from "./addBid.vue?vue&type=script&lang=js"
export * from "./addBid.vue?vue&type=script&lang=js"
import style0 from "./addBid.vue?vue&type=style&index=0&id=272ddc38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272ddc38",
  null
  
)

export default component.exports